import * as React from "react";

function SvgStateCritical(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M6.879 12.066A1.121 1.121 0 108 10.946a1.12 1.12 0 00-1.121 1.12zM8 3.465a1.12 1.12 0 00-1.121 1.12v4.483a1.121 1.121 0 002.242 0V4.585A1.12 1.12 0 008 3.465zM8 16a8 8 0 118-8 8 8 0 01-8 8z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgStateCritical);
export default ForwardRef;